import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCRMActivities extends Layout {
    labelDueToday: Label;
    labelDueTodayCount: Label;
    labelPastDue: Label;
    labelPastDueCount: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    panelDueToday: Panel;
    panelPastDue: Panel;
    panelTotal: Panel;
    sourceProspectiveSales: DataSource;
}
